import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MUILink from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from "@material-ui/core/Switch";
import { Link } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import { Licences } from '../util/HardCodedLists';
import { ModelBundle } from '../types/List';

interface attPropTypes {
    list: ModelBundle;
    open: boolean;
    handleClose: { (event: {}, reason: "backdropClick" | "escapeKeyDown"): void; (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void; };
    snackbar: any;
}

//This project contains CC-BY models from Poly Pizza. Full credits here.
//This project contains free models from Poly Pizza licenced under CC-BY.

export default function ListAttributionPopup(props: attPropTypes) {

    const CCBYlinkAtt = <span>This project contains <MUILink color="primary" href={`https://poly.pizza/l/${props.list.ListID}/credits`}>free models</MUILink> from Poly Pizza licenced under <MUILink color="primary" href="https://creativecommons.org/licenses/by/3.0/">CC-BY</MUILink></span>

    const CCBYfullText = <span>This project contains free models from Poly Pizza licenced under CC-BY (https://creativecommons.org/licenses/by/3.0/). Full credits can be found here: https://poly.pizza/l/{props.list.ListID}</span>

    const attributionRef = React.createRef();
    const [attText, setAttribuion] = React.useState({ element: CCBYlinkAtt, fulltext: false });

    const toggleText = () => {
        let state = attText.fulltext;
        state = !state;
        const ccbystate = state ? CCBYfullText : CCBYlinkAtt;
        setAttribuion({ element: ccbystate, fulltext: state });
    }

    React.useEffect(() => {
        const text = CCBYlinkAtt
        setAttribuion({ element: text, fulltext: false });
    }, [props.list.Name]);


    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">You must include attribution</DialogTitle>
            <DialogContent className='overflow-hidden'>
                {
                    <DialogContentText id="alert-dialog-description">
                        These models are published under a CC-BY 3.0 license. That means it can be used in any project (personal or commercial) so long as the text below is included. <MUILink color="primary" href="https://creativecommons.org/licenses/by/3.0/" target="_blank">Learn more</MUILink>
                    </DialogContentText>
                }

                <div style={{ padding: '30px' }}>
                    <Typography variant="h6" style={{ textAlign: 'center' }}>
                        <span ref={attributionRef}>{attText.element}</span>
                    </Typography>
                </div>
                <FormControlLabel style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
                    label="Full text links"
                    control={<Switch color="primary" checked={attText.fulltext} onChange={toggleText} />}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={() => copyElementToClipboard(attributionRef.current, props.snackbar)}>
                    Copy
                </Button>
                <Button variant="outlined" onClick={props.handleClose} color="textPrimary">
                    ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

//wat da fak
//https://stackoverflow.com/questions/34191780/javascript-copy-string-to-clipboard-as-text-html
function copyElementToClipboard(element, sb) {

    sb("Text copied!", { variant: 'success' })
    
    window.getSelection().removeAllRanges();
    let range = document.createRange();
    range.selectNode(typeof element === 'string' ? document.getElementById(element) : element);
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    
    // window?.plausible("List Attributed");
}